import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, CreateOrderBody, client } from '../../client';
import { buildOptions } from '.';

export const useCreateOrder = (
  options?: UseMutationOptions<any, ApiError | Error, CreateOrderBody, undefined>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    (body: CreateOrderBody) => client.createOrder(body),
    buildOptions(queryClient, [['session']], options)
  );
};
